// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d88cdbc0","455":"2c5de8c9","977":"4c479c4e"}[chunkId] + ".chunk.js";
};